import React from 'react';
type IgMessage = {
  from: 'in' | 'out';
  text: string;
};
type IgConversation = {
  kind: 'ig';
  timestamp?: string;
  messages: IgMessage[];
};
type WaMessage = {
  from: 'in' | 'out';
  text: string;
  time: string;
};
type WaConversation = {
  kind: 'wa';
  messages: WaMessage[];
};
type Conversation = IgConversation | WaConversation;
const conversations: Conversation[] = [{
  kind: 'ig',
  messages: [{
    from: 'out',
    text: 'Se lo acabo de enviar, por favor confírmame su recepción 🙌'
  }, {
    from: 'in',
    text: 'Si lo he recibido'
  }, {
    from: 'in',
    text: 'Muchas gracias por la comprensión'
  }, {
    from: 'in',
    text: 'Agradezco posibles publicaciones de la temática ya que estoy especializándome en el tema de salud mental deportiva'
  }]
}, {
  kind: 'ig',
  messages: [{
    from: 'in',
    text: 'Millones de gracias! Ahí llegó.. Felicitaciones por su trabajo. Impecables.. gracias por el Bonus!'
  }, {
    from: 'out',
    text: 'Excelente Johana, esperemos que disfrutes el contenido! Gracias a vos 🙌'
  }, {
    from: 'out',
    text: 'Cualquier otra consulta, estamos a tu disposición'
  }]
}, {
  kind: 'ig',
  timestamp: 'VIE, 13:03',
  messages: [{
    from: 'out',
    text: 'Ahí te lo envié! Confírmame su recepción por favor 🙌'
  }, {
    from: 'in',
    text: 'Siii me llegó'
  }, {
    from: 'in',
    text: 'Ya lo estoy mirando , es buenisimoooo'
  }, {
    from: 'in',
    text: 'Graciasssss'
  }, {
    from: 'in',
    text: 'Seguro vaya adquiriendo más'
  }, {
    from: 'out',
    text: 'Excelente! Mil gracias 🙌🥹'
  }]
}, {
  kind: 'wa',
  messages: [{
    from: 'out',
    text: 'Equipo HerramientasPsi.',
    time: '21:10'
  }, {
    from: 'in',
    text: 'Gracias!!!!!! 🙌 Buenas noches\nSuma a mis capacitaciones',
    time: '21:12'
  }, {
    from: 'out',
    text: 'Gracias a vos!!!',
    time: '21:26'
  }]
}];
function InstagramChat({
  convo
}: {
  convo: IgConversation;
}) {
  return <div className="rounded-2xl overflow-hidden shadow-md border border-slate-800 bg-[#0b0b0d] flex flex-col" data-id="element-174">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-slate-800/80" data-id="element-175">
        <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-pink-500 via-red-500 to-yellow-400 flex items-center justify-center" data-id="element-176">
          <span className="text-[10px] font-bold text-white" data-id="element-177">IG</span>
        </div>
        <span className="text-slate-200 text-sm font-medium" data-id="element-178">
          Mensaje directo
        </span>
        <span className="ml-auto text-[10px] uppercase tracking-wider text-slate-500" data-id="element-179">
          Instagram
        </span>
      </div>
      <div className="px-3 py-4 space-y-2 flex-1" data-id="element-180">
        {convo.timestamp && <p className="text-center text-[11px] text-slate-500 font-medium py-1" data-id="element-181">
            {convo.timestamp}
          </p>}
        {convo.messages.map((m, i) => <div key={i} className={`flex ${m.from === 'out' ? 'justify-end' : 'justify-start'}`} data-id="element-182">
            <p className={`max-w-[80%] px-3.5 py-2 text-sm leading-snug whitespace-pre-line ${m.from === 'out' ? 'bg-[#7b5cff] text-white rounded-2xl rounded-br-md' : 'bg-[#262629] text-slate-100 rounded-2xl rounded-bl-md'}`} data-id="element-183">
              {m.text}
            </p>
          </div>)}
      </div>
    </div>;
}
function WhatsappChat({
  convo
}: {
  convo: WaConversation;
}) {
  return <div className="rounded-2xl overflow-hidden shadow-md border border-emerald-900/40 bg-[#0b141a] flex flex-col" data-id="element-184">
      <div className="flex items-center gap-3 px-4 py-3 bg-[#202c33] border-b border-black/20" data-id="element-185">
        <div className="w-8 h-8 rounded-full bg-emerald-600 flex items-center justify-center" data-id="element-186">
          <span className="text-[10px] font-bold text-white" data-id="element-187">WA</span>
        </div>
        <span className="text-slate-100 text-sm font-medium" data-id="element-188">WhatsApp</span>
        <span className="ml-auto text-[10px] uppercase tracking-wider text-emerald-400/70" data-id="element-189">
          Chat
        </span>
      </div>
      <div className="px-3 py-4 space-y-2 flex-1" data-id="element-190">
        {convo.messages.map((m, i) => <div key={i} className={`flex ${m.from === 'out' ? 'justify-end' : 'justify-start'}`} data-id="element-191">
            <div className={`max-w-[80%] px-3 py-2 text-sm leading-snug whitespace-pre-line ${m.from === 'out' ? 'bg-[#005c4b] text-slate-50 rounded-lg rounded-tr-sm' : 'bg-[#202c33] text-slate-100 rounded-lg rounded-tl-sm'}`} data-id="element-192">
              <span data-id="element-193">{m.text}</span>
              <span className="block text-right text-[10px] text-slate-300/60 mt-1" data-id="element-194">
                {m.time}
              </span>
            </div>
          </div>)}
      </div>
    </div>;
}
export function ChatTestimonials() {
  return <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-195">
      {conversations.map((convo, idx) => convo.kind === 'ig' ? <InstagramChat key={idx} convo={convo} data-id="element-196" /> : <WhatsappChat key={idx} convo={convo} data-id="element-197" />)}
    </div>;
}